<template>
  <div class="sidebar" :data-color="activeColor" :data-image="backgroundImage" :style="sidebarStyle">
    <div class="logo">
      <a href="#" class="simple-text logo-mini">
        <div class="logo-img">
            <img :src="imgLogo" alt="">
        </div>
      </a>

      <a href="javascript:void(0)" @click="indexPath()" class="simple-text logo-normal">
        {{title}}
      </a>
    </div>
    <div class="sidebar-wrapper">
      <slot name="content"></slot>
      <md-list class="nav">
        <!--By default vue-router adds an active class to each route link. This way the links are colored when clicked-->
        <slot>
          <sidebar-link v-for="(link,index) in sidebarLinks"
                        :key="link.name + index"
                        :to="link.path"
                        :link="link">
          </sidebar-link>
        </slot>
      </md-list>
    </div>
  </div>
</template>
<script>
import SidebarLink from './SidebarLink.vue'
import MobileMenu from '@/mk_admin/pages/Layout/MobileMenu.vue'

export default{
  created() {
    if(this.$route.params.id != undefined | this.$route.params.nome != undefined){
      this.id = this.$route.params.id;
      this.clienteNome = this.$route.params.nome;
    }
   
  },
  components: {
    SidebarLink,
    MobileMenu
  },
  data() {
    return {
      id: '',
      clienteNome: ''
    };
  },
  methods: {
    indexPath(){
       this.$router.push({name: "index", params: { "id": this.id, "nome": this.clienteNome }})
    }
  },
  props: {
    title: {
      type: String,
      default: 'The Dark Book'
    },
    backgroundImage: {
      type: String,
      default: require('@/assets/img/sidebar-1.jpg')
    },
    imgLogo: {
      type: String,
      default: require('@/assets/logo.png')
    },
    activeColor: {
      type: String,
      default: 'green',
      validator: (value) => {
        let acceptedValues = ['', 'purple', 'blue', 'green', 'orange', 'red']
        return acceptedValues.indexOf(value) !== -1
      }
    },
    sidebarLinks: {
      type: Array,
      default: () => []
    },
    autoClose: {
      type: Boolean,
      default: true
    }
  },
  provide () {
    return {
      autoClose: this.autoClose
    }
  },
  computed: {
    sidebarStyle () {
      return {
        backgroundImage: `url(${this.backgroundImage})`
      }
    }
  }
}
</script>
<style>
  @media screen and (min-width: 991px) {
    .nav-mobile-menu{
      display: none;
    }
  }
</style>
